
import React, { useState } from "react";
import MobileNotificationFilters from "../mobile/MobileNotificationFilters";
import MobileNotificationCardList from "../mobile/MobileNotificationCardList";
import { SupabaseNotification } from "@/types/notifications";
import { useNotificationFilters } from "@/hooks/notifications/useNotificationFilters";

interface MobileNotificationListProps {
  notifications: SupabaseNotification[];
  filteredNotifications: SupabaseNotification[];
  sortedNotifications: SupabaseNotification[];
  isLoading: boolean;
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  formatDate: (date: string) => string;
  handleNotificationClick: (id: string) => void;
  handleArchive: (e: React.MouseEvent, id: string) => void;
  handleRestore: (e: React.MouseEvent, id: string) => void;
  handleDelete: (e: React.MouseEvent, id: string) => void;
  viewMode: "active" | "archived";
  unreadCount?: number;
}

const MobileNotificationList = ({
  notifications,
  filteredNotifications,
  sortedNotifications,
  isLoading,
  searchTerm,
  setSearchTerm,
  formatDate,
  handleNotificationClick,
  handleArchive,
  handleRestore,
  handleDelete,
  viewMode,
  unreadCount = 0
}: MobileNotificationListProps) => {
  const [showFilters, setShowFilters] = useState(false);
  
  // Use the same hook as desktop for consistent behavior
  const {
    unreadFilter,
    selectedStatuses,
    filteredUnreadCount,
    displayedNotifications,
    handleStatusChange,
    toggleUnreadFilter
  } = useNotificationFilters({
    sortedNotifications,
    unreadCount
  });
  
  return (
    <div className="flex flex-col space-y-4">
      <MobileNotificationFilters 
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        unreadFilter={unreadFilter}
        toggleUnreadFilter={toggleUnreadFilter}
        selectedStatuses={selectedStatuses}
        setSelectedStatuses={handleStatusChange}
        unreadCount={filteredUnreadCount}
        showFilters={showFilters}
        setShowFilters={setShowFilters}
      />
      
      <MobileNotificationCardList 
        notifications={displayedNotifications}
        isLoading={isLoading}
        formatDate={formatDate}
        handleNotificationClick={handleNotificationClick}
        handleArchive={handleArchive}
        handleRestore={handleRestore}
        handleDelete={handleDelete}
        viewMode={viewMode}
        selectedStatuses={selectedStatuses}
      />
    </div>
  );
};

export default MobileNotificationList;
